import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown} from 'antd';
import { DownloadOutlined, FileExcelOutlined, FileTextOutlined} from '@ant-design/icons';
import {saveAs} from 'file-saver';
import '../App.css';

const CSV_EXPORT = "CSV_EXPORT";
const XML_EXPORT = "XML_EXPORT";

class DownloadButton extends Component {

    constructor(props) {
        super(props);
        this.download = this.onExport.bind(this);

        this.items = [
          {
            key: CSV_EXPORT,
            icon: <FileExcelOutlined/>,
          },
          ...(this.props.downloadUrl !== undefined ? [{
            key: XML_EXPORT,
            icon: <FileTextOutlined/>,
          }] : []),     

        ];
      }

    onExport(e)
    {
        if (e.key === XML_EXPORT)
        {
            saveAs(this.props.downloadUrl, "data.xml");
        }
        else if (e.key === CSV_EXPORT)
        {
            this.props.onCSVExport();
        }
        else
        {
            console.log('Unknown menu key', e);
        }
    }
    
    render() {
      return (
        <div className="download-button-container">
            <Dropdown menu={{
              items:this.items, 
              onClick: (e) => {this.onExport(e)}
              }} className="download-button">
                <Button type="ghost"><DownloadOutlined/>
                </Button>
            </Dropdown>
        </div>
    );
  }

  static propTypes = {
    onCSVExport: PropTypes.func.isRequired
  };
}

export default DownloadButton;